import React from 'react';
import { Navigate } from 'react-router';
import { useOktaAuth } from '@okta/okta-react';
import OktaSignInWidget from './OktaSignInWidget';
import { oktaconfig } from '../config';

const Login = () => {
  const { authState } = useOktaAuth();


  const onSuccess = (res: any) => {
    console.log('Login success:', res);
    // The LoginCallback component will handle the redirect
  };

  const onError = (err: any) => {
    console.error('Login error:', err);
  };

  // If already authenticated, redirect to home
  if (authState?.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!authState) {
    return null;
  }

  return (
    <div className='parent-container' style={{ padding: '20px' }}>
      <div style={{ maxWidth: '400px', margin: '0 auto' }}>
        <OktaSignInWidget
          config={oktaconfig.widget}
          onSuccess={onSuccess}
          onError={onError}
        />
      </div>
    </div>
  );
};

export default Login;